import { useCustomDispatch } from "../../../hooks";
import * as storage from "../../../state/storage";

interface Properties {
  dummyRef: React.MutableRefObject<null>;
}

const AppendButton: React.FC<Properties> = ({ dummyRef, ...props }) => {
  const dispatch = useCustomDispatch();

  const handleAdd = (e: any) => {
    e.preventDefault();
    dispatch(storage.actions.append("uwu"));
    setTimeout(() => (dummyRef?.current as any).scrollIntoView(), 0);
  };

  return (
    <button
      onClick={handleAdd}
      className="ml-auto block bg-green-400 text-white font-bold px-4 py-2 rounded-md"
      {...props}
    >
      Add
    </button>
  );
};

export default AppendButton;
